var _path, _path2, _path3, _rect, _circle, _rect2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHipaaCompliantBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 140",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "hipaa-badge-title"
  }, "HIPAA Compliant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "hipaa-badge-title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 4 L112 22 V66 C112 100 90 124 60 136 C30 124 8 100 8 66 V22 Z",
    fill: "#1f3a5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12 L104 27.5 V66 C104 95.5 85.5 116.5 60 127.5 C34.5 116.5 16 95.5 16 66 V27.5 Z",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 44 V37 A9 9 0 0 1 69 37 V44",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43,
    width: 30,
    height: 23,
    rx: 3,
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 52,
    r: 3.2,
    fill: "#1f3a5f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 53,
    width: 2.8,
    height: 7,
    rx: 1,
    fill: "#1f3a5f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 91,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 23,
    fontWeight: 700,
    fill: "#ffffff"
  }, "HIPAA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 108,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: 1.4,
    fill: "#ffffff"
  }, "COMPLIANT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipaaCompliantBadge);
export default __webpack_public_path__ + "static/media/hipaa-compliant-badge.1f01894745efb30a032bf41433df8136.svg";
export { ForwardRef as ReactComponent };